import { BaseModel } from "../base.model";
import { Contact } from "../customer-contact";
import { Customer } from "../customer.model";
import { L2PUBProject } from "./submodels/l2pub-project.model";
import { User } from "../users.model";
import { CFJobType, ICustomData, IProject, Project } from "./project.model";
import { GeneralInfo, IGeneralInfo } from "./submodels/general-info.model";

// Master project
export interface IMasterCustomData extends ICustomData {
    // general: IGeneralMaster;
}

export interface IGeneralMaster {
    id_maitre: string;
    final_name: string;
    is_old?: boolean;
}

export interface IMasterProject extends IProject {
    custom: IMasterCustomData;
}

export class GeneralMaster implements IGeneralMaster {
    id_maitre: string;
    final_name: string;
    is_old?: boolean;

    constructor(data: Partial<IGeneralMaster> = {}) {
        this.id_maitre = data.id_maitre || '';
        this.final_name = data.final_name || '';
        this.is_old = data.is_old;
    }
}

export class MasterCustomData extends BaseModel<IMasterCustomData> implements IMasterCustomData {
    protected __build: { [path: string]: new (data: any) => any; } = {
        'general_info': GeneralInfo,
    };
    general_info: GeneralInfo = new GeneralInfo();

    constructor(data: Partial<IMasterCustomData> = {}) {
        super(data);
        this.init(data);
    }
}

export class MasterProject extends Project {
    protected __build: { [path: string]: new (data: any) => any; } = {
        'custom': MasterCustomData,
    };
    type: CFJobType = CFJobType.JOB_MAITRE;
    custom: MasterCustomData = new MasterCustomData();

    constructor(data: Partial<IMasterProject> = {}) {
        super(data);
        this.init(data);
    }
}

